import { reactive } from "vue";

export const confirmDialogState = reactive({
  visible: false,
  title: "",
  text: "",
  confirmButtonText: "Aceptar",
  cancelButtonText: "Cancelar",
  confirmButtonClass: "btn btn-xs ms-1 bg-gradient-primary",
  cancelButtonClass: "btn btn-xs btn-outline-primary me-1",
  showCancelButton: true,
});

let activeResolver = null;

function resetState() {
  confirmDialogState.visible = false;
  confirmDialogState.title = "";
  confirmDialogState.text = "";
  confirmDialogState.confirmButtonText = "Aceptar";
  confirmDialogState.cancelButtonText = "Cancelar";
  confirmDialogState.confirmButtonClass = "btn btn-xs ms-1 bg-gradient-primary";
  confirmDialogState.cancelButtonClass = "btn btn-xs btn-outline-primary me-1";
  confirmDialogState.showCancelButton = true;
}

function resolveDialog(payload) {
  if (typeof activeResolver === "function") {
    activeResolver(payload);
  }
  activeResolver = null;
  resetState();
}

export function openConfirmDialog(options = {}) {
  if (typeof activeResolver === "function") {
    activeResolver({ isConfirmed: false, dismiss: "replaced" });
  }

  confirmDialogState.title = options.title || "";
  confirmDialogState.text = options.text || "";
  confirmDialogState.confirmButtonText = options.confirmButtonText || "Aceptar";
  confirmDialogState.cancelButtonText = options.cancelButtonText || "Cancelar";
  confirmDialogState.confirmButtonClass =
    options?.customClass?.confirmButton || "btn btn-xs ms-1 bg-gradient-primary";
  confirmDialogState.cancelButtonClass =
    options?.customClass?.cancelButton || "btn btn-xs btn-outline-primary me-1";
  confirmDialogState.showCancelButton = options.showCancelButton !== false;
  confirmDialogState.visible = true;

  return new Promise((resolve) => {
    activeResolver = resolve;
  });
}

export function cancelConfirmDialog() {
  resolveDialog({ isConfirmed: false, dismiss: "cancel" });
}

export function acceptConfirmDialog() {
  resolveDialog({ isConfirmed: true });
}
